module.exports = __webpack_public_path__ + "img/query.f874726f.jpg";